import {
    AggregateFunctions,
    ApiQueryEndpoints,
    Filter,
    FilterOperators,
} from "~/modules/filters/types";
import { MEASURE_SLUGS } from "~/consts";
import {
    VisualizationConfig,
    VisualizationMode,
    VisualizationModeTypes,
} from "~/modules/visualization/components/Timeseries/types";
import { ASSET_TIMESERIES_V4_API_TOOLS_CONTROLS } from "~/modules/visualization/components/Timeseries/consts";
import { ExportTableNames } from "~/modules/downloads/types";
import {
    AssetTimeseriesColumns,
    AssetTimeseriesGroupBy,
} from "~/modules/asset_timeseries_v4/types";
import { ChartTypes } from "~/modules/token_timeseries/types";

// // // //

const visualizationConfig: VisualizationConfig = {
    area: false,
    seriesChartType: ChartTypes.line,
    enableZoom: false,
    showTotal: true,
    currencyValueDecimals: 4,
    height: 350,
    yAxis: {
        min: undefined,
    },
    legend: {
        itemWidth: 125,
        layout: "vertical",
        align: "right",
        verticalAlign: "top",
    },
};

// // // //

export function getNetAssetValueChart(props: {
    key: string;
    label: string;
    filters: Filter[];
    defaultGroupBy?: AssetTimeseriesGroupBy;
    enableGroupByControls?: boolean;
    ignoreDownloadsFeatureFlag?: boolean;
}): VisualizationMode {
    const {
        key,
        label,
        filters,
        enableGroupByControls = true,
        defaultGroupBy = AssetTimeseriesGroupBy.asset,
        ignoreDownloadsFeatureFlag = false,
    } = props;
    return {
        key,
        type: VisualizationModeTypes.area,
        endpoint: ApiQueryEndpoints.AssetTimeseriesV4,
        content: {
            label,
        },
        queryControls: {
            groupBy: {
                enabled: enableGroupByControls,
                forceUpdate: true,
                value: defaultGroupBy,
                allowedOptions: [
                    AssetTimeseriesGroupBy.asset,
                    AssetTimeseriesGroupBy.issuer,
                    AssetTimeseriesGroupBy.jurisdictionCountry,
                    AssetTimeseriesGroupBy.manager,
                ],
            },
        },
        visualizationConfig: {
            ...visualizationConfig,
        },
        visualizationControls: {
            navigator: {
                active: true,
                enabled: true,
                forceUpdate: true,
            },
            // "Show % of Total" isn't applicable to NAV values
            stacked: {
                enabled: false,
                active: false,
                forceUpdate: true,
            },
        },
        query: {
            aggregate: {
                aggregateFunction: AggregateFunctions.Sum,
                groupBy: AssetTimeseriesGroupBy.asset,
            },
            filter: {
                operator: FilterOperators.And,
                filters: [
                    ...filters,
                    {
                        field: AssetTimeseriesColumns.measureSlug,
                        operator: FilterOperators.Equals,
                        value: MEASURE_SLUGS.net_asset_value_dollar,
                    },
                ],
            },
            sort: {
                direction: "asc",
                field: "date",
            },
            pagination: {
                page: 1,
                perPage: 25,
            },
        },
        apiTools: ASSET_TIMESERIES_V4_API_TOOLS_CONTROLS,
        dataExportControls: {
            enabled: true,
            filename: key,
            ignoreFeatureFlag: ignoreDownloadsFeatureFlag,
            exportTableName: ExportTableNames.asset_timeseries_v4,
        },
    };
}
